import React, { Component } from "react";
import { Helmet } from "react-helmet";

class Headbody extends Component {

    render() {
        return(
            <React.Fragment>
                <Helmet>
                    <meta charset="utf-8"></meta>
                    <meta http-equiv="X-UA-Compatible" content="IE=edge"></meta>
                    <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale = 1.0"></meta>
                    
                    <meta name="title" content="ITechMed"></meta>
                    <meta name="description" content=""></meta>
                    <meta name="Keywords" content=""></meta>
                    <meta name="author" content="Jairo Júnio - Elogos Comunicação"></meta>
                    <meta name="copyright" content="ITechMed"></meta>

                    <meta name="msapplication-TileColor" content="#00BFBF"></meta>
                    <meta name="theme-color" content="#00BFBF"></meta>
                    <title>ItechMed</title>
                    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
                    <script type="text/javascript" src="../../assets/js/jquery.min.js"></script>
                    <script type="text/javascript" src="../../assets/js/jquery-3.3.1.min.js"></script>
                    <script type="text/javascript" src="../../assets/js/bootstrap.min.js"></script>
                    <script type="text/javascript" src="../../assets/js/owl.carousel.js"></script>
                    <script type="text/javascript" src="../../assets/js/owl.carousel.min.js"></script>
                    <script type="text/javascript" src="../../assets/js/calls.js"></script>
                    <link rel="stylesheet" href="../../assets/css/bootstrap.min.css"></link>
                    <link rel="stylesheet" href="../../assets/css/estilo.css"></link>
                    <link rel="stylesheet" href="../../assets/css/responsive.css"></link>
                    <link rel="stylesheet" href="../../assets/css/card-effect.css"></link>
                    <link rel="stylesheet" href="../../assets/css/owl.carousel.min.css"></link>
                    <link rel="stylesheet" href="../../assets/css/owl.theme.default.css"></link>
                </Helmet>
            </React.Fragment>
        );
    }
}

export default Headbody;